<script>
export default {
  name: 'CpShowImageInCard',
  components: {
    handleImageError: require('../mixins/utils').default,
  },
  created() {
    this.hash = this.getUrlHash();
  },
  props: {
    image: { type: String },
    link: { type: String, default: null },
    altMessage: { type: String, default: 'Post Image' },
    fullWidth: { type: Boolean, default: false },
  },
  data() {
    return {
      isRectangular: false,
      hash: '',
    };
  },
  methods: {
    checkAspectRatio(event) {
      const { naturalWidth, naturalHeight } = event.target;
      this.isRectangular = naturalWidth > naturalHeight;
    },
  },
};
</script>
<template>
  <a v-if="!!image" :href="hash !== '#post' ? link : null" :class="['img-container', { 'disabled-link': hash === '#post' }]">
    <img
      :src="`${image}`"
      :alt="altMessage"
      width="100%"
      @load="checkAspectRatio"
      @error="handleImageError"
      loading="lazy"
      :class="{ rectangle: isRectangular, 'not-rectangle': !isRectangular, fullWidth: fullWidth }"
    />
  </a>
</template>

<style scoped>
.img-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.img-container.disabled-link {
  cursor: default !important;
  pointer-events: none;
  text-decoration: none;
}
.img-container.disabled-link:hover {
  text-decoration: none;
  opacity: 1;
}
.img-container.disabled-link img {
  pointer-events: auto;
}
.img-container img {
  aspect-ratio: auto;
}
.img-container img.not-rectangle {
  max-width: 45%;
}
.img-container img.rectangle {
  max-width: 65%;
}
.img-container img.fullWidth {
  max-width: 100%;
}
</style>
